import React, { useState } from "react";
// import components
import DCard from "../../components/DCard";
import PageHeading from "../../components/PageHeading";
import { useQuery } from "react-query";
import orderServices from "../../services/orders";
import { Navigate, useNavigate } from "react-router-dom";
import DSpinner from "../../components/DSpinner";
import Table from "../../components/Table";
import DButton from "../../components/DButton";
import moment from "moment";
import { orderStatusBtnStyle, statusMessage } from "../../utils/functions";

const columns = [
    { Header: "رقم الطلب", accessor: "id" },
    { Header: "معرف المنتج", accessor: "subitem_id" },
    { Header: "اسم المنتج", accessor: "name" },
    { Header: "اسم المستخدم", accessor: "username" },
    { Header: "اسم اللاعب", accessor: "playername" },
    { Header: "معرف اللاعب", accessor: "playerid" },
    { Header: "السعر", accessor: "total_cost" },
    { Header: "الكمية", accessor: "amount" },
    { Header: "المعرف الخارجي", accessor: "external_id" },
    { Header: "نوع المعاملة", accessor: "type" },
    { Header: "تاريخ الطلب", accessor: "created_at" },
    { Header: "حالة الطلب", accessor: "status" },
    { Header: "التحكم", accessor: "action" },
];
const InProgressOrders = ({ title }) => {
    const [currentPage, setCurrentPage] = useState(0);
    const navigate = useNavigate();
    const { data, isLoading, error } = useQuery(
        ["progressOrders", currentPage],
        () => orderServices.getProgressOrders(currentPage + 1),
        { refetchInterval: 5000, refetchIntervalInBackground: 5000 }
    );
    const statusSorrundWithButton = cell => {
        return (
            <DButton
                className={`${
                    cell.value === "في الانتظار"
                        ? "text-third-color"
                        : "text-white"
                } min-w-[100px] rounded-[50px_!important]`}
                bgColor={orderStatusBtnStyle(cell.value)}
            >
                {cell.render("Cell")}
            </DButton>
        );
    };
    const editOrder = id => {
        navigate(`/orders/edit/${id}`);
    };
    const formattedData = data => {
        if (data.length > 0) {
            return data.map(d => ({
                ...d,
                name: d.subitem.name,
                subitem_id: d.subitem_id,
                external_id: d.external_id ? d.external_id : "لايوجد",
                status: statusMessage(d.status),
                created_at: moment(d.created_at).format("hh:mm:ss YYYY-MM-DD"),
                username: d.user.username,
                playername: d.order_info.player_name,
                playerid: d.order_info.player_id,
                type: d.subitem.api_id ? "آلي" : "يدوي",
                // action: d.subitem.api_id ? (
                //     "----"
                // ) : (
                //     <DButton
                //         onClick={() => editOrder(d.id)}
                //         bgColor="secondry"
                //         className=" px-4 rounded-[50px_!important]"
                //     >
                //         تعديل
                //     </DButton>
                // ),
                action: (
                    <DButton
                        onClick={() => editOrder(d.id)}
                        bgColor="secondry"
                        className=" px-4 rounded-[50px_!important]"
                    >
                        تعديل
                    </DButton>
                ),
            }));
        }
        return [];
    };
    if (error) {
        return <Navigate to="/404" />;
    }
    return (
        <div>
            <PageHeading>{title}</PageHeading>
            <DCard className={`${isLoading ? "min-h-[400px]" : ""}`}>
                {isLoading ? (
                    <DSpinner />
                ) : (
                    <Table
                        head={columns}
                        body={formattedData(data.data.data)}
                        setCurrentPage={setCurrentPage}
                        currentPage={currentPage}
                        totalData={data.data.total}
                        elements={{ status: statusSorrundWithButton }}
                    />
                )}
            </DCard>
        </div>
    );
};

export default InProgressOrders;
